<template>
  <div class="ele-payment">
    <div class="ele-payment-top">
      <span>电费缴纳</span>
    </div>
    <div class="ele-payment-bottom">
      <div class="search-criteria">
        <div class="search-criteria-l">
          <el-select v-model="provincesName" clearable placeholder="请选择省份" @change="provincesChange">
            <el-option
              v-for="item in provincesList"
              :key="item.province"
              :label="item.province"
              :value="item.province">
            </el-option>
          </el-select>
          <el-select v-model="cityName" clearable placeholder="请选择城市" @change="cityChange">
            <el-option
              v-for="item in cityList"
              :key="item.city"
              :label="item.city"
              :value="item.city">
            </el-option>
          </el-select>
          <el-select v-model="stationName" clearable placeholder="请选择场站" @change="stationChange">
            <el-option
              v-for="item in stationList"
              :key="item.station_id"
              :label="item.station_name"
              :value="item.station_id">
            </el-option>
          </el-select>
          <el-date-picker
            v-model="time"
            type="date"
            placeholder="年/月/日">
          </el-date-picker>
          <el-button class="search" @click="searchClick()">查询</el-button>
        </div>
        <div style="clear:both;"></div>
      </div>
      <div class="ele-payment-table">
        <el-table
          :data="yemiandata"
          :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
          border
          style="width: 100%">
          <el-table-column
            prop="city"
            label="城市"
            width="">
          </el-table-column>
          <el-table-column
            prop="station_name"
            label="场站"
            width="">
          </el-table-column>
          <el-table-column
            prop="date"
            label="年/月"
            width="100">
          </el-table-column>
          <el-table-column
            prop="charge"
            label="电表读数">
          </el-table-column>
          <el-table-column
            prop="power"
            label="电量（度）"
            width="">
          </el-table-column>
          <el-table-column
            prop="price"
            label="电价（元/度）">
          </el-table-column>
          <el-table-column
            prop="fee"
            label="电费（元）"
            width="">
          </el-table-column>
          <el-table-column
            prop="last_updated_time"
            label="最后更新时间"
            width="">
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
        background
        layout="prev, pager, next"
        @size-change="handleSizeChange" 
        @current-change="currentChange"
        :total="totalNum">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { parseDateFilter } from "@/filters";
export default {
  data () {
    return {
      provincesList:[],
      provincesName:"",
      cityList:[],
      cityName:"",
      stationList:[],
      stationName:"",
      time:"",
      tableData: [],
      // 页面需要展现的数据
      yemiandata:[],
      // 页面展现条数
      datanum:10,
      // 开始页数
      startnum:0,
      // 结束页数
      endnum:1,
      // 一共多少页
      totalNum:0,
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.getProvinces();
      this.getDataList();
    });
  },
  beforeRouteEnter(to, from, next) {
    window.document.querySelector("body").setAttribute("style", "background-image:none");
    window.document.body.style.backgroundColor = "#EFEFEF";
    next();
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "#001928";
    next();
  },
  methods: {
    handleSizeChange(data){
      // debugger
    },
    currentChange(data){
      this.endnum = data;
      this.startnum = data-1;
      if(this.totalNum > 10){
        this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      } else {
        this.yemiandata=this.tableData;
      }
    },
    getDataList(province,city,stationId,time){
      time = parseDateFilter(time, 'yyyy-MM-dd');
      let year = "";
      let month = "";
      if(province == undefined){
        province = "";
      }
      if(city == undefined){
        city = "";
      }
      if(stationId == undefined){
        stationId = "";
      }
      if(time == undefined){
        year = "";
        month = "";
      } else {
        year = time.substring(0,4);
        month = time.substring(5,7);
      }
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action:"getElectricFees",
          province:province,
          city:city,
          station_id:stationId,
          year:year,
          month:month,
      };
      this.$api({
          method: "post",
          url: "/api.php/ElectricFee/index",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                this.tableData = su.data.list;
                this.totalNum = this.tableData.length;
                if(this.totalNum > 10){
                  // debugger
                  this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
                } else {
                  this.yemiandata=this.tableData;
                }
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                this.$router.push('/login');
                this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    getProvinces(){
        let params = {
            uid: localStorage.getItem("uid"),
            token: localStorage.getItem("token"),
        };
        this.$api({
            method: "post",
            url: "/api.php/Currency/get_provinces",
            data: params,
            transformRequest: [
            data => {
                let ret = "";
                for (let it in data) {
                ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
                }
                return ret;
            }
            ]
        })
            .then(su => {
                if(su.data.code == 1){
                    this.provincesList = su.data.list;
                } else if(su.data.code == 300) {
                    localStorage.clear(); 
                    this.$router.push('/login');
                    this.$message.warning(su.data.message);
                } else if (su.data.code == 900)  {
              } else {
                    this.$message.warning(su.data.message);
                }
            })
            .catch(err => {
        });
    },
    provincesChange(province){
      this.cityName = "";
      this.cityList = [];
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          province:province,
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_citys",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.cityList = su.data.list;
              } else if(su.data.code == 300) {
                  localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    cityChange(city){
      this.stationList = [];
      this.stationName = "";
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          city:city,
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_stations",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.stationList = su.data.list;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    stationChange(stationId){
      this.stationName = stationId;
    },
    searchClick(){
      this.totalNum = 0;
      this.startnum = 0;
      this.endnum = 1;
      this.getDataList(this.provincesName,this.cityName,this.stationName,this.time);
    },
  }
}
</script>

<style scoped lang="scss">
.ele-payment {
  .ele-payment-top {
    width: 98%;
    height: 60px;
    margin-left: 1%;
    margin-top: 16px;
    background-color: #ffffff;
    text-align: left;
    span {
      line-height: 60px;
      font-size: 16px;
      color: #0076bc;
      margin-left: 20px;
      font-weight: 700;
    }
  }
  .ele-payment-bottom {
    width: 98%;
    margin-left: 1%;
    margin-top: 12px;
    background-color: #ffffff;
    padding-top: 20px;
    padding-bottom: 64px;
    .search-criteria {
      width: 98%;
      margin-left: 1%;
      .search-criteria-l {
        float: left;
        .el-select {
          float: left;
          margin-right: 10px;
        }
        .el-input {
          width: 15%;
          float: left;
          margin-right: 10px;
        }
        .search {
          float: left;
          background-color: #0071bd;
          border:none;
          color: #feffff;
        }
        .search:active {
          background-color: #409EFF;
        }
      }
    }
    .ele-payment-table {
      width: 98%;
      margin-left: 1%;
      margin-top: 24px;
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      padding-bottom: 24px;
      margin-top: 20px;
      margin-right: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/stationManagement/electricityPayment.vue